import { WorkOrderStatus } from '@backoffice-frontend/graphql'
import { useTranslation } from 'react-i18next'

export const workOrderStatusBadgeVariant = (
  status: WorkOrderStatus,
): 'success' | 'critical' | 'neutral' => {
  switch (status) {
    case WorkOrderStatus.Closed:
      return 'success'
    case WorkOrderStatus.Cancelled:
      return 'critical'
    default:
      return 'neutral'
  }
}

export const useWorkOrderStatusTranslation = () => {
  const { t } = useTranslation()

  return (statusType: WorkOrderStatus): string => {
    const options: Record<string, string> = {
      CANCELLED: t('workOrdersComponents_workOrdersTable_status_cancelled'),
      CLOSED: t('workOrdersComponents_workOrdersTable_status_completed'),
      IN_PROGRESS: t('workOrdersComponents_workOrdersTable_status_inProgress'),
      OPEN: t('workOrdersComponents_workOrdersTable_status_open'),
    }
    return options[statusType] ?? statusType
  }
}
